export default {
    parts: [
        'container',
        'layout',
        'firstColumn',
        'confirmationHeading',
        'orderNumberRow',
        'checkIcon',
        'orderNumberText',
        'bodyText',
        'emailText',
        'editOrderText',
        'editOrderLink',
        'csatSurveyWrap',
        'registeredCtaStack',
        'guestStack',
        'guestButton',
        'secondColumn',
        'orderDetailsHeaderWrap',
        'orderDetailsHeading',
        'detailCard',
        'sectionHeading',
        'sectionStack',
        'shippingMethodWrap',
        'shippingMethodRow',
        'shippingMethodIconWrap',
        'shippingMethodContent',
        'shippingMethodText',
        'shippingMethodDescription',
        'shippingMethodEtaText',
        'shippingMethodStoreAddress',
        'shippingMethodPrice',
        'paymentHeading',
        'paymentSummaryWrap',
        'billingSectionWrap',
        'orderSummaryWrap',
        'orderSummary',
        'confirmationLeadText',
        'primaryColumnBodyText',
        'orderManageTitleText',
        'orderManageBodyText'
    ],
    baseStyle: {
        container: {
            maxWidth: '957px',
            py: 8
        },
        layout: {
            wrap: {base: 'wrap', lg: 'nowrap'},
            justifyContent: {base: 'space-between', lg: 'flex-start'},
            gap: {base: 0, lg: '125px'}
        },
        firstColumn: {
            flex: {base: '100%', lg: 1},
            w: {base: '100%', lg: '344px'},
            maxW: {base: '100%', lg: '344px'},
            minW: 0
        },
        confirmationHeading: {
            textStyle: 'webH1',
            mb: 6
        },
        orderNumberRow: {
            align: 'center',
            gap: '8px',
            mb: {base: 6}
        },
        checkIcon: {
            display: 'block',
            width: '32px',
            height: '32px'
        },
        orderNumberText: {
            textStyle: 'webH3'
        },
        bodyText: {
            textStyle: 'bodySmRegular'
        },
        emailText: {
            textStyle: 'bodySmRegular',
            mb: 6
        },
        editOrderText: {
            textStyle: 'bodySmRegular',
            mb: {base: 12, lg: 16}
        },
        editOrderLink: {
            textStyle: 'bodySmLink'
        },
        registeredCtaStack: {
            mb: {base: 12, lg: 16}
        },
        csatSurveyWrap: {
            w: '100%',
            mb: {base: 12, lg: 16}
        },
        guestStack: {
            mb: {base: 12, lg: 0},
            gap: 6
        },
        guestButton: {
            w: '100%'
        },
        secondColumn: {
            flex: {base: '100%', lg: 1},
            w: {base: '100%', lg: '458px'},
            maxW: {base: '100%', lg: '458px'},
            minW: 0
        },
        orderDetailsHeaderWrap: {
            mb: '24px'
        },
        orderDetailsHeading: {
            textStyle: 'webH2'
        },
        detailCard: {
            textStyle: 'bodyXsSRegular',
            p: '16px',
            border: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            mb: '12px'
        },
        principalSectionHeading: {
            textStyle: 'webH3',
            mb: 6
        },
        sectionHeading: {
            textStyle: 'webH4',
            mb: '10.5px'
        },
        sectionStack: {
            spacing: 0
        },
        shippingMethodWrap: {
            mb: 8
        },
        shippingMethodRow: {
            display: 'flex',
            justifyContent: 'space-between',
            gap: 3,
            alignItems: 'flex-start'
        },
        shippingMethodIconWrap: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minW: '24px'
        },
        shippingMethodContent: {
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: '7px'
        },
        shippingMethodText: {
            textStyle: 'webH4'
        },
        shippingMethodDescription: {
            textStyle: 'bodyXsSRegular'
        },
        shippingMethodEtaText: {
            textStyle: 'bodyXsSRegular'
        },
        shippingMethodStoreAddress: {
            textStyle: 'bodyXsSRegular',
            color: 'webTypo.textPrimary',
            pt: '8px'
        },
        shippingMethodPrice: {
            textStyle: 'bodyXsSRegular',
            whiteSpace: 'nowrap'
        },
        paymentSummaryWrap: {
            mb: 4
        },
        billingSectionWrap: {
            borderTop: '1px solid',
            borderColor: 'webTheme.strokeTertiary',
            pt: '16px',
            mt: '16px'
        },
        orderSummaryWrap: {
            mt: '48px'
        }
    },
    variants: {
        garage: {
            confirmationLeadText: {
                fontSize: {base: '12px', md: '16px'},
                lineHeight: {base: '18px', md: '20px'},
                fontWeight: 'medium',
                color: 'webTypo.textPrimary',
                textTransform: 'capitalize'
            },
            primaryColumnBodyText: {
                fontSize: {base: '12px', md: '16px'},
                lineHeight: {base: '18px', md: '20px'},
                fontWeight: 'normal',
                color: 'webTypo.textPrimary'
            },
            orderManageTitleText: {
                fontSize: {base: '12px', md: '16px'},
                lineHeight: {base: '18px', md: '20px'},
                fontWeight: '500',
                color: 'webTypo.textPrimary'
            },
            orderManageBodyText: {
                fontSize: {base: '12px', md: '16px'},
                lineHeight: {base: '18px', md: '20px'},
                fontWeight: '400',
                color: 'webTypo.textPrimary'
            }
        },
        dynamite: {
            confirmationLeadText: {
                fontSize: {base: '14px', md: '16px'},
                lineHeight: {base: '20px', md: '20px'},
                fontWeight: 'normal',
                color: 'webTypo.textPrimary',
                textTransform: 'capitalize'
            },
            primaryColumnBodyText: {
                fontSize: {base: '14px', md: '16px'},
                lineHeight: {base: '20px', md: '20px'},
                fontWeight: 'normal',
                color: 'webTypo.textPrimary'
            },
            orderManageTitleText: {
                fontSize: {base: '14px', md: '16px'},
                lineHeight: '20px',
                fontWeight: '500',
                color: 'webTypo.textPrimary'
            },
            orderManageBodyText: {
                fontSize: {base: '14px', md: '16px'},
                lineHeight: {base: '20px', md: '20px'},
                fontWeight: '400',
                color: 'webTypo.textPrimary'
            }
        }
    }
}
